var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCashnote = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.404 10.778c-.518 0-1.029.34-1.298.685-.82.96-1.913 1.715-3.35 1.715-2.256 0-3.965-1.853-3.965-3.978s1.71-3.977 3.966-3.977c1.436 0 2.529.754 3.35 1.714.27.348.786.685 1.297.685.945 0 1.596-.722 1.596-1.52 0-.312-.064-.652-.263-.948C15.447 3.228 13.364 2 10.757 2 6.723 2 3.58 5.154 3.58 9.2c0 4.047 3.145 7.2 7.177 7.2 2.597 0 4.69-1.228 5.98-3.153.199-.297.263-.63.263-.948 0-.792-.653-1.52-1.596-1.52Z",
  fill: "#192D82"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.578 18a1.59 1.59 0 0 0 1.579-1.6c0-.883-.707-1.6-1.579-1.6-.871 0-1.578.717-1.578 1.6 0 .884.707 1.6 1.578 1.6Z",
  fill: "#2D91FF"
})));
export default SvgCashnote;